module.exports = __webpack_public_path__ + "img/neukirchen_pfarrkirche.9a93c64f.jpg";